/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Includes_HeadingInputs */

const es_landing_price_includes_heading = /** @type {(inputs: Landing_Price_Includes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué incluye tu gestión`)
};

const gl_landing_price_includes_heading = /** @type {(inputs: Landing_Price_Includes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que inclúe a túa xestión`)
};

const en_landing_price_includes_heading = /** @type {(inputs: Landing_Price_Includes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What your management includes`)
};

/**
* | output |
* | --- |
* | "What your management includes" |
*
* @param {Landing_Price_Includes_HeadingInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_includes_heading = /** @type {((inputs?: Landing_Price_Includes_HeadingInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Includes_HeadingInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_includes_heading(inputs)
	if (locale === "en") return en_landing_price_includes_heading(inputs)
	return es_landing_price_includes_heading(inputs)
});